import { Box, Stack, Typography } from "@mui/material"
import { Repeat } from "lib/@components/repeat"
import { If } from "lib/@components/switch"
import { FailureRow } from "./failure-row"

export function RecentFailuresSection({ failures }) {
    return (
        <If value={!!failures?.length}>
            <Box data-cy="sso-recent-failures">
                <Typography variant="subtitle2" gutterBottom>
                    Recent Failed Sign-ins
                </Typography>
                <Typography variant="caption" color="text.secondary">
                    The most recent SSO sign-in failures for this configuration, including which SAML claim the email
                    address was taken from. Use these to diagnose identity provider claim-mapping problems.
                </Typography>
                <Stack spacing={1} sx={{ mt: 1 }}>
                    <Repeat list={failures ?? []} item={<FailureRow />} pass="failure" />
                </Stack>
            </Box>
        </If>
    )
}
